import React from "react";

import { Avatar as AntAvatar } from "antd";

import { LazyLoadImage } from "components";

export const AvatarImage = ({ size = "s", style, title, image, dataTestId, className }) => {
  const getSize = () => {
    if (size === "xl") {
      return 180;
    }
    if (size === "l") {
      return 160;
    }
    if (size === "m") {
      return 72;
    }
    if (size === "xm") {
      return 56;
    }
    if (size === "xs") {
      return 32;
    }
    return 48;
  };

  return (
    <AntAvatar className={className} data-testid={dataTestId} size={getSize()} style={style}>
      <LazyLoadImage alt={title} src={image} />
    </AntAvatar>
  );
};
